export const PURPOSE_OPTIONS = [
  'agriculturalProducts',
  'agrotechnics',
  'workingСapital',
  'capitalExpenses',
  'businessDevelopment',
  'refinancing',
]
